import React from "react";

export default function GoalMetricCard({ title, value, colorClass = "bg-light" }) {
  return (
    <div className="col-6 mt-3">
      <div className={`card ${colorClass}`}>
        <div className="card-body" style={{ padding: "0.8rem" }}>
          {title}
          <div className="h2 mb-0">{value || "—"}</div>
        </div>
      </div>
    </div>
  );
}
